/* eslint-disable */
import apiMessages from './messages/api';
import tableMessages from './messages/table';
import env from 'runtime.env';

export default {
  consumer: {
    routes: {
      paths: {
        '/unrecoverable_error': {
          componentName: 'UNRECOVERABLE',
          pathLocaleId: 'route_unrecoverable_error',
          exact: true,
          guard: [
            {
              type: 'DIRECT',
            },
          ],
        },
      },
    },
    theme: {
      breakpoints: {
        values: {
          xs: 0,
          sm: 375,
          md: 768,
          lg: 1024,
          xl: 1920,
        },
      },
      palette: {
        error: {
          main: '#ff0000',
        },
        warning: {
          main: '#ffa21a',
        },
        success: {
          main: '#00cc00',
        },
        background: {
          default: '#ffffff',
        },
        loaderBackground: {
          default: 'rgba(255,255,255,0.7)',
        },
        input:{ borderColor: '#ADADAD'},
        text: {
          primary: '#373A40',
        },
        textField: {
          backgroundColor: '#ffffff',
        },
        type: 'light',
        action: {
          disabled: '#FFFFFF',
          disabledBackground: '#BDC7CD',
          selected: '#ffffff',
          selectedBorder: '#1A6B96',
          default: '#6F6F6F',
        },
        primary: {
          main: '#01618E',
        },
        secondary: {
          main: '#0097a7',
        },
        brand: {
          main: '#008ED4',
        },
        link: {
          main: '#0070BD',
        },
        opacity: {
          hidden: {
            opacity: 0,
          },
          visible: {
            opacity: 1,
          },
        },
        programs: {
          table: {
            text: '#474747',
            fontSize: 15,
            row: {
              faded: '#EEE',
            },
            pagination: {
              caption: '#9C9EA4',
              item: '#fff',
              selectedItem: '#E2E2E2',
            },
            header: {
              text: '#fff',
            },
          },
          background: {
            default: '#f6f6f6',
          },
          card: {
            background: '#F0F0F0',
            border: '#F6F6F6',
            darkBackGround: '#DFDFDF',
          },
          fontFamily: {
            proximaNova: 'Proxima Nova',
          },
          fields: {
            color: {
              gray: '#ADADAD',
            },
          },
        },
        table: {
          headerBackgroundColor: '#01618E',
          headerContrastColor: '#FFF',
          evenRowBackgroundColor: '#f2f2f2',
          oddRowBackgroundColor: '#FFF',
          borderColor: '#F0F0F0'
        },
        breadcrumb: {
          main: '#232323',
        },
        mainContainer: {
          backgroundColor: '#F6F6F6',
        },
        search: {
          icon: '#01618E',
          text: '#727272',
          button: {
            text: '#ffffff',
            background: '#01618E',
          },
          divider: '#727272',
          placeholder: 'rgba(49,49,49,0.4)',
          border: '0.1rem solid #D4DADF',
          fontFamily: 'Proxima Nova',
        },
        dataSection: {
          header: {
            divider: '#979797',
          },
          dataDetail: {
            card: {
              background: '#FFFFFF',
              titleText: '#0E0E0E',
              divider: '#DADADA',
              boxShadow: {
                first: 'rgba(0,0,0,0.2)',
                second: 'rgba(0,0,0,0.14)',
                third: 'rgba(0,0,0,0.12)',
              },
              button: {
                background: '#01618E',
                text: '#FFFFFF',
              },
              secondaryButton: {
                background: '#FFFFFF',
                text: '#01618E',
              },
            },
          },
        },
        fields: {
          color: '#000000',
        },
        organizations: {
          organization: {
            main: {
              detail: {
                divider: '#DADADA',
                item: {
                  titleText: '#373737',
                  valueText: '#373737',
                },
              },
              contact: {
                item: {
                  titleText: '#747474',
                  titleDetailText: '#333333',
                  valueText: '#0E0E0E',
                  valueDetailText: '#373737',
                },
              },
            },
            brick: {
              dataTitle: '#747474',
              dataValue: '#333333',
              titleText: '#0E0E0E',
              button: '#01618E',
            },
            boxShadow: {
              primary: 'rgba(0,0,0,0.2)',
              secondary: 'rgba(0,0,0,0.14)',
              tertiary: 'rgba(0,0,0,0.12)',
            },
            inActiveOrganization: '#EAEAEA',
          },
        },
        genericHeader: {
          breadcrumb: {
            main: '#232323',
          },
          title: {
            main: '#01618E',
          },
          fontFamily: 'Proxima Nova',
        },
        addItemHeader: {
          button: {
            border: '#01618E',
            main: '#01618E',
          },
        },
        keycloakCell: {
          notSyncedColor: '#BDC7CD',
        },
        welcome: {
          background: 'linear-gradient(180deg, #2B799F 0%, #00618E 100%)',
          shadow: 'rgba(0,0,0,0.12)',
          brick: {
            background: '#FFFFFF',
            text: '#01618E',
            shadow: ['rgba(0,0,0,0.2)', 'rgba(0,0,0,0.14)', 'rgba(0,0,0,0.12)'],
          },
          header: {
            text: '#FFFFFF',
          },
        },
        pagedList: {
          header: {
            status: {
              text: '#6B6B6B',
            },
            title: {
              text: '#6A6A6A',
            },
          },
          footer: {
            selected: '#E2E2E2',
            hover: '#E2E2E2',
            page: {
              text: '#01618E',
            },
            arrow: {
              text: '#333333',
            },
          },
        },
        popoverMenu: {
          paper: {
            background: '#FFFFFF',
          },
          text: {
            fontFamily: 'Proxima Nova Light',
            fontFamilyRegular: 'Proxima Nova',
            fontSize: '1.5rem',
            color: '#232323',
          },
          img: {
            height: '7.1rem',
            width: '7.1rem',
          },
        },
        consent: {
          brick: {
            dataTitle: '#474747',
            dataValue: '#474747',
            button: '#01618E',
          },
          boxShadow: {
            primary: 'rgba(0,0,0,0.2)',
            secondary: 'rgba(0,0,0,0.14)',
            tertiary: 'rgba(0,0,0,0.12)',
          },
        },
      },
      typography: {
        htmlFontSize: 10,
        useNextVariants: true,
        fontFamilyRegular: 'Proxima Nova',
        fontFamilyLight: 'Proxima Nova Light',
        fontFamilyBold: 'Proxima Nova Bold',
        fontWeightMedium: 500,
        fontWeightBold: 700,
        h1: {
          fontWeight: 600,
          fontSize: '3.4rem',
          lineHeight: '4.1rem',
        },
        h5: {
          fontWeight: 600,
          fontSize: '2rem',
          lineHeight: '2.4rem',
        },
        h6: {
          fontWeight: 600,
          fontSize: '1.6rem',
          lineHeight: '2.3rem',
        },
        subtitle1: {
          fontSize: '1.2rem',
          lineHeight: '1.4rem',
        },
        subtitle2: {
          fontSize: '1.2rem',
          fontWeight: '400',
          lineHeight: '1.5rem',
        },
        subtitle3: {
          fontWeight: '700',
          fontSize: '1.6rem',
        },
        body1: {
          fontSize: '1.6rem',
          fontWeight: '400',
          lineHeight: '2.2rem',
        },
        body2: {
          fontSize: '1.4rem',
          fontWeight: '400',
        },
        button: {
          fontWeight: '600',
          lineHeight: '1.2rem',
        },
        footer: {
          fontFamily: 'Proxima Nova',
          fontSize: '1.2rem',
          color: '#686868',
          lineHeight: '1.2rem',
        },
        fieldLabel: {
          fontSize: '1.4rem',
          fontWeight: 600,
          lineHeight: '1.5rem',
          fontFamily: 'Montserrat',
          letterSpacing: 0,
          color: '0E0E0E',
        },
      },
      icon: {
        drawerToggle: '#4A4A4A',
      },
      spinner: {
        marginLeft: '50%',
        marginRight: '50%',
      },
      overrides: {
        MuiFormControl: {
          root: {
            backgroundColor: '#FFFFFF',
          },
        },
      },
    },
    localesConfiguration: {
      supportedLanguages: ['en', 'fr'],
      defaultLocale: 'en',
      placeholders: {
        s3_path: `${env.RT_S3_ASSETS}`,
      },
      messages: {
        ...apiMessages,
        ...tableMessages,
        ecard_button_label: {
          en: 'Download your card here',
          fr: 'Téléchargez votre carte ici',
        },
        footer_sti_copyright: {
          en:
            "©2019 STI Technologies Limited.<br/>All rights reserved. <a target='_blank' href='https://smartsti.com/privacy'>Privacy Policy</a><br/>",
          fr:
            "©2019 STI Technologies Limited.<br/>Tous droits réservés. <a target='_blank' href='https://smartsti.com/fr/politique'>Politique de confidentialité</a><br/>",
        },
        localeSwitcher_button_label_en: {
          en: 'Français',
          fr: 'Français',
        },
        localeSwitcher_button_label_fr: {
          en: 'English',
          fr: 'English',
        },
        route_unrecoverable_error: {
          en: '/unrecoverable_error',
          fr: '/erreur_irrécupérable',
        },
        form_submit_button: {
          en: 'SUBMIT',
          fr: 'SOUMETTRE',
        },
        form_save_button: {
          en: 'SAVE',
          fr: 'ENREGISTRER',
        },
        form_reset_button: {
          en: 'RESET',
          fr: 'RÉINITIALISER',
        },
        form_fields_required: {
          en: '<sup>*</sup> Are required fields',
          fr: '<sup>*</sup> Champ obligatoire',
        },
        dialog_dismiss_button_label: {
          en: 'CLOSE',
          fr: 'FERMER',
        },
        form_fields_autocomplete_not_found: {
          en: 'no result for',
          fr: 'aucun résultat pour',
        },
        form_fields_autocomplete_service_not_available: {
          en: 'service unavailable',
          fr: 'Service indisponible',
        },
      },
    },
    components: {
      UNRECOVERABLE: {
        componentName: 'ErrorPage',
      },
    },
  },
};
